var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1.55228 12 2 12.4477 2 13L2 17.6C2 17.8209 2.17909 18 2.4 18H17.6C17.8209 18 18 17.8209 18 17.6V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13V18V19.6C20 19.8209 19.8209 20 19.6 20H18H2H0.4C0.179086 20 0 19.8209 0 19.6V18V13C0 12.4477 0.447715 12 1 12Z",
    fill: "#ECF0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3994 10.5C11.1785 10.5 10.9994 10.3209 10.9994 10.1L10.9994 0.4C10.9994 0.179086 10.8203 0 10.5994 0H9.39939C9.17848 0 8.99939 0.179085 8.99939 0.399999L8.99939 10.1C8.99939 10.3209 8.82031 10.5 8.59939 10.5H7.348C7.01607 10.5 6.82856 10.881 7.03104 11.144L9.68243 14.5883C9.84255 14.7963 10.1562 14.7963 10.3164 14.5883L12.9677 11.144C13.1702 10.881 12.9827 10.5 12.6508 10.5H11.3994Z",
    fill: "#ECF0F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.37cebc25dc6c7a49fd24ff62ca7a1048.svg";
export { ForwardRef as ReactComponent };